import * as React from 'react';
import { FormControl } from '@common/components/form-control';
import { I18n } from 'react-redux-i18n';

import { Flex } from '@common/components/Flex';
import { Ellipsis } from '@common/components/Ellipsis';
import { Button } from '@common/components/Button';
import { FileUpload } from '@common/components/FileUpload';

import './Profile.styles.scss';

export class Profile extends React.Component {
  get sections() {
    const { data, canChangePassword } = this.props;

    return [
      {
        fields: [
          {
            label: 'Username',
            component: <Ellipsis id="tx-profile-user-name" maxWidth="300px" text={data.userName} />
          },
          {
            label: 'First Name',
            component: <FormControl id="tx-profile-first-name" value={data.firstName} name="firstName" onChange={this.handleDataChange} />
          },
          {
            label: 'Last Name',
            component: <FormControl id="tx-profile-last-name" value={data.lastName} name="lastName" onChange={this.handleDataChange} />
          },
          {
            label: 'Email',
            component: <FormControl id="tx-profile-email-id" value={data.email} name="email" onChange={this.handleDataChange} />
          },
        ]
      },
      {
        condition: canChangePassword,
        title: 'Change password',
        fields: [
          {
            label: 'Current',
            component: (
              <FormControl 
                id="tx-profile-old-password" 
                type="password" 
                value={data.oldPassword || ''} 
                name="oldPassword" 
                onChange={this.handleDataChange} 
              />
            )
          },
          {
            label: 'New',
            component: (
              <FormControl 
                id="tx-profile-new-password" 
                type="password" 
                value={data.newPassword || ''} 
                name="newPassword" 
                onChange={this.handleDataChange} 
              />
            )
          },
          {
            label: 'Confirm',
            component: (
              <FormControl 
                id="tx-profile-new-password-confirmed" 
                type="password" 
                value={data.newPasswordConfirmed || ''} 
                name="newPasswordConfirmed" 
                onChange={this.handleDataChange} 
              />
            )
          },
        ]
      },
    ].filter(({ condition = true }) => condition);
  }

  handleDataChange = (e) => {
    e.persist();

    const { value, name } = e.target;
    const { data, onChange } = this.props;

    onChange({
      ...data,
      [name]: value
    });
  }

  handleImageUpload = async ({ file, base64 }) => {
    const { data, onChange } = this.props;

    onChange({
      ...data,
      clearImage: false,
      imageUrl: base64,
      profileImage: file,
    });
  }

  handleImageRemove = () => {
    const { data, onChange } = this.props;

    onChange({
      ...data,
      imageUrl: undefined,
      clearImage: true,
      profileImage: undefined,
    });
  }

  render() {
    const { data } = this.props;

    return (
      <div className="Profile">
        <Flex width="100%">
          <div className="Profile__image-section">
            <img src={data.imageUrl} id="img-profile" />
            <FileUpload 
              withBase64
              config={{
                maxSize: 256000000,
                accept: ['image/jpeg', 'image/png'],
                multiple: false,
              }}
              placeholderProps={{
                id: 'anc-change-profile-image'
              }}
              placeholder="Change"
              onUpload={this.handleImageUpload}
            />
            <Button id="anc-remove-profile-image" variant="text" text="Remove" onClick={this.handleImageRemove} />
          </div>

          <div className="Profile__fields">
            {this.sections.map(({ title, fields }, i) => (
              <div key={i} className="Profile__fields__section">
                {title && <h3 className="Profile__fields__title">{I18n.t(title)}</h3>}
                {fields.map((field) => (
                  <Flex className="Profile__fields__item" key={field.label}>
                    <span className="Profile__fields__item__label">{I18n.t(field.label)}</span>
                    <div className="Profile__fields__item__component">{field.component}</div>
                  </Flex>
                ))}
              </div>
            ))}
          </div>
        </Flex>
      </div>
    );
  }
}
